<table mat-table [dataSource]="this.tasks?.data" class="w-full">

    <!-- avatar -->
    <ng-container matColumnDef="avatar">
        <th mat-header-cell *matHeaderCellDef>  </th>
        <td mat-cell *matCellDef="let element" class="w-1/12 text-center items">
            <div class="flex items-center justify-center">
                <form-type-widget [clasificacion]="element.clasificacion"></form-type-widget>
            </div>
        </td>
    </ng-container>

    <!-- Detalle Column -->
    <ng-container matColumnDef="detalleSolicitud">
      <th mat-header-cell *matHeaderCellDef> Solicitud </th>
      <td mat-cell *matCellDef="let element" class="w-4/12 px-2"> 
            <div class="py-4" >

                <div class="text-sm">
                    <mat-icon class="text-md">tag</mat-icon>
                    <span>Solicitud: </span>  <span class="font-bold">{{ element.tareaUuid}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">description</mat-icon>
                    <span>Nombre: </span>  <span class="font-bold">{{ element.nombreTarea}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">person</mat-icon>
                    <span>Solicitante: </span>  <span class="font-bold">{{ element.solicitante}}</span>
                </div>

                <div class="text-sm" >
                    <mat-icon class="text-md">format_list_numbered</mat-icon>
                    <span>Correlativo: </span>  <span class="font-bold">{{ element.correlativo ??  element.tags}}</span>
                </div>

                <div class="text-sm">
                    <mat-icon class="text-md">today</mat-icon>
                    <span>Fecha de Ingreso: </span>  <span class="font-bold">{{element.fechaIngreso | date}}</span>
                </div>
                <div class="text-sm">
                    <mat-icon class="text-md">person</mat-icon>
                    <span>Creado por: </span>  <span class="font-bold">{{ element.creadoPor.nombreCompleto}}</span>
                </div>

                

            </div>

      </td>
    </ng-container>
  
    <!-- Seccion -->
    <ng-container matColumnDef="seccion">
        <th mat-header-cell *matHeaderCellDef> Sección </th>
        <td mat-cell *matCellDef="let element" class="w-2/12">
            <div>
                <div><span class="text-sm font-bold p-1 px-3 rounded-lg">  {{element.seccion?.descripcion}} </span></div>
            </div>
        </td>
    </ng-container>

    <!-- Estado Column -->
    <ng-container matColumnDef="estado">
      <th mat-header-cell *matHeaderCellDef class="px-2"> Estado </th>
      <td mat-cell *matCellDef="let element" class="w-2/12 px-2 "> 
        <status-sticker [estado]="element.estadoTarea.descripcion" [color1]="element.estadoTarea.valor1" [color2]="element.estadoTarea.valor2"></status-sticker>
      </td>
    </ng-container>
  
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> </th>
      <td mat-cell *matCellDef="let element"  class="w-1/12 px-2"> 
            <button mat-icon-button (click)="openTaskDetails(element.tareaUuid)">
                <mat-icon>open_in_new</mat-icon>
            </button>
      </td>
    </ng-container>
  
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  
  <mat-paginator [length]="this.tasks?.total" [pageSize]="pageSizes" [hidePageSize]="true"></mat-paginator>